<div class="baja-container">
    <div class="baja-card">
        <div class="logo-container">
            <img src="/assets/images/logo_NDG.svg" alt="logo" class="logo">
        </div>
        <div class="icon-container">
            <mat-icon>update</mat-icon>
        </div>
        <p>
            Te informamos que esta página ya no se encuentra disponible debido a una actualización de nuestros sistemas. 
            Para acceder a tus gestiones, por favor ingresá a nuestra nueva Extranet:
        </p>
        
        <a href="https://extranet.ngranos.com.ar/" class="btn-nueva-plataforma">
            Acceder a la Extranet
        </a>

        <div class="footer-mensaje">
            <p>Ante cualquier consulta durante esta transición, tu comercial a cargo se encuentra a disposición.</p>
        </div>
    </div>
</div>
